import { createSlice } from "@reduxjs/toolkit";
import { Iaccount } from "../../../pages/accounts/IAccount";
// this code for slice value for EditCard
export const EditCard = createSlice({
  name: "EditCard",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    data: {} as Iaccount,
  },
  reducers: {
    edit_EditCard: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_EditCard: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
    },
    failure_api_call_EditCard: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
    },
    EditCard_is_success: (state) => {
      state.isSuccess = false;
    },
    EditCard_complete_api: (state) => {
      state.api_completed = false;
    },
    clearCard: (state) => {
      state.data = {};
    },
  },
});
export default EditCard.reducer;
export const {
  edit_EditCard,
  success_api_call_EditCard,
  EditCard_complete_api,
  failure_api_call_EditCard,
  EditCard_is_success,
  clearCard,
} = EditCard.actions;
